<template>
	<div class="c_editorContent"><slot></slot></div>
</template>
<script setup lang="ts"></script>

<style lang="scss" scoped>
.c_editorContent {
	background-color: var(--color-bg-mid);
	padding: 2rem;
	border-radius: 0.8rem;
}
</style>
